module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/bella-rosenthal-26dbaaac2cd1efb8b64a01cf3538fd0b.jpg";